









import { Vue, Component } from 'vue-property-decorator';
import T from '../../../lang';

@Component
export default class OutputOnlyDownload extends Vue {
  get zipUrl(): string {
    // This should eventually be dynamic
    return '/problem/output-only/files.zip';
  }

  T = T;
}
